import MuiPagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";

type PaginationProps = {
  page: number;
  count: number;
  onChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  disabled?: boolean;
};

const Pagination = ({ page, count, onChange, disabled }: PaginationProps) => {
  if (count <= 1) return null;

  return (
    <Box display="flex" justifyContent="flex-end" marginTop={4}>
      <MuiPagination
        variant="outlined"
        shape="rounded"
        page={page}
        count={count}
        onChange={onChange}
        disabled={disabled}
      />
    </Box>
  );
};

export default Pagination;
